<template>
	<div>
		<div @click="expandMenu" class="flex items-center">
			<img
				v-if="menuExpanded"
				class="cursor-pointer"
				src="@/assets/img/admin-menu-abierto.svg"
				alt="menu-abierto"
			/>
			<img
				v-if="!menuExpanded"
				class="cursor-pointer"
				src="@/assets/img/admin-menu.svg"
				alt="menu"
			/>
			<span class="ml-2 uppercase font-medium hidden md:block">{{
				itemSelected
			}}</span>
		</div>
		<div class="flex flex-col mt-4 mr-8 custom" v-if="menuExpanded">
			<div>
				<router-link
					@click.native="itemSelected = $t('news')"
					class="text-primary flex items-center no-underline p-2"
					to="/admin/listado/noticias"
				>
					<img
						class="mr-2"
						src="@/assets/img/admin-noticias.svg"
						alt="Notícias"
					/>
					<span class="hidden md:block">{{ $t('news') }}</span>
				</router-link>
			</div>
			<div>
				<router-link
					@click.native="itemSelected = $t('Banners')"
					class="text-primary flex items-center no-underline p-2"
					to="/admin/listado/banners"
				>
					<img
						class="mr-2"
						src="@/assets/img/admin-banners.svg"
						alt="Banners"
					/>
					<span class="hidden md:block">{{ $t('Banners') }}</span>
				</router-link>
			</div>
			<div>
				<router-link
					@click.native="itemSelected = $t('Link')"
					class="text-primary flex items-center no-underline p-2"
					to="/admin/listado/links"
				>
					<img class="mr-2" src="@/assets/img/admin-links.svg" alt="Links" />
					<span class="hidden md:block">{{ $t('Link') }}</span>
				</router-link>
			</div>
			<div>
				<router-link
					@click.native="itemSelected = $t('Bonos')"
					class="text-primary flex items-center no-underline p-2"
					to="/admin/listado/bonos"
				>
					<img class="mr-2" src="@/assets/img/admin-bonos.svg" alt="Bonos" />
					<span class="hidden md:block">{{ $t('Bonos') }}</span>
				</router-link>
			</div>
			<div>
				<router-link
					@click.native="itemSelected = $t('Contactos')"
					class="text-primary flex items-center no-underline p-2"
					to="/admin/listado/contactos"
				>
					<img
						class="mr-2"
						src="@/assets/img/admin-contactos.svg"
						alt="Contactos"
					/>
					<span class="hidden md:block">{{ $t('Contactos') }}</span>
				</router-link>
			</div>
			<div>
				<router-link
					@click.native="itemSelected = $t('Empresas')"
					class="text-primary flex items-center no-underline p-2"
					to="/admin/listado/empresas"
				>
					<img
						class="mr-2"
						src="@/assets/img/admin-empresas.svg"
						alt="Empresas"
					/>
					<span class="hidden md:block">{{ $t('Empresas') }}</span>
				</router-link>
			</div>
			<div>
				<router-link
					@click.native="itemSelected = $t('Organizaciones')"
					class="text-primary flex items-center no-underline p-2"
					to="/admin/listado/organizaciones"
				>
					<img
						class="mr-2"
						src="@/assets/img/admin-organizaciones.svg"
						alt="Organizaciones"
					/>
					<span class="hidden md:block">{{ $t('Organizaciones') }}</span>
				</router-link>
			</div>
			<div>
				<router-link
					@click.native="itemSelected = $t('Usuarios')"
					class="text-primary flex items-center no-underline p-2"
					to="/admin/listado/usuarios"
				>
					<img class="mr-2" src="@/assets/img/contacto.svg" alt="Usuarios" />
					<span class="hidden md:block">{{ $t('Usuarios') }}</span>
				</router-link>
			</div>
			<div>
				<router-link
					@click.native="itemSelected = $t('Roles')"
					class="text-primary flex items-center no-underline p-2"
					to="/admin/listado/roles"
				>
					<img class="mr-2" src="@/assets/img/admin-permisos.svg" alt="Roles" />
					<span class="hidden md:block">{{ $t('Roles') }}</span>
				</router-link>
			</div>
			<div>
				<router-link
					@click.native="itemSelected = $t('contratacion')"
					class="text-primary flex items-center no-underline p-2"
					to="/admin/listado/contratos"
				>
					<img class="mr-2" src="@/assets/img/contratacion.svg" alt="Firmas" />
					<span class="hidden md:block">{{ $t('contratacion') }}</span>
				</router-link>
			</div>
			<div>
				<router-link
					@click.native="itemSelected = $t('Genera_firmas')"
					class="text-primary flex items-center no-underline p-2"
					to="/admin/generar-firmas"
				>
					<img class="mr-2" src="@/assets/img/editar.svg" alt="Firmas" />
					<span class="hidden md:block">{{ $t('Genera_firmas') }}</span>
				</router-link>
			</div>
			<div>
				<router-link
					@click.native="itemSelected = $t('Emails')"
					class="text-primary flex items-center no-underline p-2"
					to="/admin/emails"
				>
					<img class="mr-2" src="@/assets/img/email.svg" alt="Firmas" />
					<span class="hidden md:block">{{ $t('Emails') }}</span>
				</router-link>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	data() {
		return {
			itemSelected: '',
			menuExpanded: true
		}
	},
	computed: {
		...mapGetters({
			user: 'login/user'
		})
	},
	created() {
		this.$store.dispatch('adminMenu', this.menuExpanded)
	},
	methods: {
		expandMenu() {
			this.menuExpanded = !this.menuExpanded
			this.$store.dispatch('adminMenu', this.menuExpanded)
		}
	}
}
</script>

<style scoped>
a:hover a:hover span,
div a:hover span,
a:hover a.router-link-active span,
div a.router-link-active span {
	font-weight: bold;
}
.custom div:nth-child(odd) {
	background: #f5f5f5;
}
</style>
